"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exitWorldCharacters = void 0;
const Party_1 = require("../classes/Party");
const WorldCharacter_1 = require("../classes/WorldCharacter");
const definables_1 = require("definables");
const resetParty_1 = require("./resetParty");
const exitWorldCharacters = (worldCharacterIDs) => {
    const affectedPartyIDs = [];
    for (const worldCharacterID of worldCharacterIDs) {
        const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldCharacterID);
        const party = (0, definables_1.getDefinable)(Party_1.Party, worldCharacter.player.character.party.id);
        party.playerIDs = party.playerIDs.filter((partyPlayerID) => partyPlayerID !== worldCharacter.playerID);
        if (affectedPartyIDs.includes(party.id) === false) {
            affectedPartyIDs.push(party.id);
        }
        worldCharacter.remove();
    }
    for (const affectedPartyID of affectedPartyIDs) {
        const affectedParty = (0, definables_1.getDefinable)(Party_1.Party, affectedPartyID);
        if (affectedParty.playerIDs.length === 0) {
            affectedParty.remove();
        }
        else {
            (0, resetParty_1.resetParty)(affectedPartyID);
        }
    }
};
exports.exitWorldCharacters = exitWorldCharacters;
